const eosErrorArray = {
    '0': {
        'en_US': 'none',
        'zh_HK': '无異常',
    },
    '1': {
        'en_US': 'recode not found',
        'zh_HK': '记录没有找到',
    },
    '2': {
        'en_US': 'recode existing',
        'zh_HK': '记录已经存在',
    },
    '3': {
        'en_US': 'address illegal',
        'zh_HK': '地址非法',
    },
    '4': {
        'en_US': 'symbol mismatch',
        'zh_HK': '不匹配',
    },
    '5': {
        'en_US': 'address mismatch',
        'zh_HK': '地址不匹配',
    },
    '6': {
        'en_US': 'not common xin',
        'zh_HK': '没有跨入地址',
    },
    '7': {
        'en_US': 'status incorrest',
        'zh_HK': '状态異常',
    },
    '8': {
        'en_US': 'param incorrect',
        'zh_HK': '参数错误',
    },
    '9': {
        'en_US': 'no auth',
        'zh_HK': '没有权限',
    },
    '3010000': {
        'en_US': 'chain type exception',
        'zh_HK': '链类型異常',
    },
    '3010001': {
        'en_US': 'Invalid name',
        'zh_HK': '無效的名称',
    },
    '3010002': {
        'en_US': 'Invalid public key',
        'zh_HK': '無效的公钥',
    },
    '3010003': {
        'en_US': 'Invalid private key',
        'zh_HK': '無效的私鑰',
    },
    '3010004': {
        'en_US': 'Invalid authority',
        'zh_HK': '無效的授權',
    },
    '3010005': {
        'en_US': 'Invalid action',
        'zh_HK': '無效的动作',
    },
    '3010006': {
        'en_US': 'Invalid transaction',
        'zh_HK': '無效的交易',
    },
    '3010007': {
        'en_US': 'Invalid ABI',
        'zh_HK': '無效的ABI',
    },
    '3010008': {
        'en_US': 'Invalid block ID',
        'zh_HK': '無效的區塊ID',
    },
    '3010009': {
        'en_US': 'Invalid transaction ID',
        'zh_HK': '無效的交易ID',
    },
    '3010010': {
        'en_US': 'Invalid packed transaction',
        'zh_HK': '無效的打包交易',
    },
    '3010011': {
        'en_US': 'Invalid asset',
        'zh_HK': '無效的资产',
    },
    '3010012': {
        'en_US': 'Invalid chain ID',
        'zh_HK': '無效的链ID',
    },
    '3010013': {
        'en_US': 'Invalid fixed key',
        'zh_HK': '無效的固定密钥',
    },
    '3010014': {
        'en_US': 'Invalid symbol',
        'zh_HK': '無效的代币符号',
    },
    '3015000': {
        'en_US': 'ABI exception',
        'zh_HK': 'ABI異常',
    },
    '3015001': {
        'en_US': 'No ABI found',
        'zh_HK': '没有找到ABI',
    },
    '3015002': {
        'en_US': 'Invalid Ricardian Clause',
        'zh_HK': '無效的李嘉图语句',
    },
    '3015003': {
        'en_US': 'Invalid Ricardian Action',
        'zh_HK': '無效的李嘉图动作',
    },
    '3015004': {
        'en_US': 'The type defined in the ABI is invalid',
        'zh_HK': 'ABI中定义的类型無效',
    },
    '3015005': {
        'en_US': 'Duplicate type definition in the ABI',
        'zh_HK': 'ABI中存在重复定义的类型',
    },
    '3015006': {
        'en_US': 'Duplicate struct definition in the ABI',
        'zh_HK': 'ABI中存在重复定义的结构',
    },
    '3015007': {
        'en_US': 'Duplicate action definition in the ABI',
        'zh_HK': 'ABI中存在重复定义的动作',
    },
    '3015008': {
        'en_US': 'Duplicate table definition in the ABI',
        'zh_HK': 'ABI中存在重复定义的数据表',
    },
    '3015009': {
        'en_US': 'Duplicate error message definition in the ABI',
        'zh_HK': 'ABI中存在重复定义的错误信息',
    },
    '3015010': {
        'en_US': 'ABI serialization time has exceeded the deadline',
        'zh_HK': 'ABI序列化时间超过截止值',
    },
    '3015011': {
        'en_US': 'ABI recursive definition has exceeded the max recursion depth',
        'zh_HK': 'ABI中的递归定义超过最大允许深度',
    },
    '3015012': {
        'en_US': 'Circular definition is detected in the ABI',
        'zh_HK': 'ABI中检测到循环定义',
    },
    '3015013': {
        'en_US': 'Unpack data exception',
        'zh_HK': '解包数据发生異常',
    },
    '3015014': {
        'en_US': 'Pack data exception',
        'zh_HK': '打包数据发生異常',
    },
    '3015015': {
        'en_US': 'Duplicate variant definition in the ABI',
        'zh_HK': 'ABI中存在重复定义的变量',
    },
    '3015016': {
        'en_US': 'ABI has an unsupported version',
        'zh_HK': '不支持的ABI版本',
    },
    '3020000': {
        'en_US': 'Fork database exception',
        'zh_HK': '分叉数据库異常',
    },
    '3020001': {
        'en_US': 'Block can not be found',
        'zh_HK': '找不到區塊',
    },
    '3030000': {
        'en_US': 'Block exception',
        'zh_HK': '區塊異常',
    },
    '3030001': {
        'en_US': 'Unlinkable block',
        'zh_HK': '无法链接的區塊',
    },
    '3030002': {
        'en_US': 'Transaction outputs in block do not match transaction outputs from applying block',
        'zh_HK': '指定區塊与待应用區塊中的交易输出不匹配',
    },
    '3030003': {
        'en_US': 'Block does not guarantee concurrent execution without conflicts',
        'zh_HK': '區塊不能保证无冲突并发執行',
    },
    '3030004': {
        'en_US': 'Shard locks in block are incorrect or mal-formed',
        'zh_HK': '區塊的分片锁不正确或格式错误',
    },
    '3030005': {
        'en_US': 'Block exhausted allowed resources',
        'zh_HK': '區塊已耗尽许可的资源',
    },
    '3030006': {
        'en_US': 'Block is too old to push',
        'zh_HK': '區塊太陈旧，无法提交',
    },
    '3030007': {
        'en_US': 'Block is from the future',
        'zh_HK': '區塊时间过早',
    },
    '3030008': {
        'en_US': 'Block is not signed with expected key',
        'zh_HK': '區塊签名与密钥不一致',
    },
    '3030009': {
        'en_US': 'Block is not signed by expected producer',
        'zh_HK': '區塊签名与出块人不一致',
    },
    '3040000': {
        'en_US': 'Transaction exception',
        'zh_HK': '交易異常',
    },
    '3040001': {
        'en_US': 'Error decompressing transaction',
        'zh_HK': '解压交易失敗',
    },
    '3040002': {
        'en_US': 'Transaction should have at least one normal action',
        'zh_HK': '交易至少应当包含一个常规动作',
    },
    '3040003': {
        'en_US': 'Transaction should have at least one required authority',
        'zh_HK': '交易至少应当包含一个授權',
    },
    '3040004': {
        'en_US': 'Context-free action should have no required authority',
        'zh_HK': '上下文无关动作不应当包含授權',
    },
    '3040005': {
        'en_US': 'Expired Transaction',
        'zh_HK': '超时的交易',
    },
    '3040006': {
        'en_US': 'Transaction Expiration Too Far',
        'zh_HK': '交易超时过久',
    },
    '3040007': {
        'en_US': 'Invalid Reference Block',
        'zh_HK': '無效的参考块',
    },
    '3040008': {
        'en_US': 'Duplicate transaction',
        'zh_HK': '重复的交易',
    },
    '3040009': {
        'en_US': 'Duplicate deferred transaction',
        'zh_HK': '重复的延迟交易',
    },
    '3040010': {
        'en_US': 'Context free action is not allowed inside generated transaction',
        'zh_HK': '在生成的交易中不允许出现上下文无关动作',
    },
    '3040011': {
        'en_US': 'The transaction can not be found',
        'zh_HK': '交易找不到',
    },
    '3040012': {
        'en_US': 'Pushing too many transactions at once',
        'zh_HK': '同时提交过多的交易',
    },
    '3040013': {
        'en_US': 'Transaction is too big',
        'zh_HK': '交易过大',
    },
    '3040014': {
        'en_US': 'Unknown transaction compression',
        'zh_HK': '未知的交易压缩方式',
    },
    '3050000': {
        'en_US': 'Action validate exception',
        'zh_HK': '动作验证異常',
    },
    '3050001': {
        'en_US': 'Account name already exists',
        'zh_HK': '账号名已经存在',
    },
    '3050002': {
        'en_US': 'Invalid Action Arguments',
        'zh_HK': '無效的动作参数',
    },
    '3050003': {
        'en_US': 'eosio_assert_message assertion failure',
        'zh_HK': '消息条件验证失敗',
    },
    '3050004': {
        'en_US': 'eosio_assert_code assertion failure',
        'zh_HK': '代码条件验证失敗',
    },
    '3050005': {
        'en_US': 'Action can not be found',
        'zh_HK': '找不到动作',
    },
    '3050006': {
        'en_US': 'Mismatch between action data and its struct',
        'zh_HK': '动作数据和结构定义不匹配',
    },
    '3050007': {
        'en_US': 'Attempt to use unaccessible API',
        'zh_HK': '试图访问不许可的API',
    },
    '3050008': {
        'en_US': 'Abort Called',
        'zh_HK': '中止被调用',
    },
    '3050009': {
        'en_US': 'Inline Action exceeds maximum size limit',
        'zh_HK': '内联动作超过允许的最大尺寸',
    },
    '3060000': {
        'en_US': 'Database exception',
        'zh_HK': '数据库異常',
    },
    '3060001': {
        'en_US': 'Permission Query Exception',
        'zh_HK': '许可查询異常',
    },
    '3060002': {
        'en_US': 'Account Query Exception',
        'zh_HK': '账号查询異常',
    },
    '3060003': {
        'en_US': 'Contract Table Query Exception',
        'zh_HK': '合约数据表查询異常',
    },
    '3060004': {
        'en_US': 'Contract Query Exception',
        'zh_HK': '合约查询異常',
    },
    '3060100': {
        'en_US': 'Guard Exception',
        'zh_HK': '保护性異常',
    },
    '3060101': {
        'en_US': 'Database usage is at unsafe levels',
        'zh_HK': '数据库利用处于不安全等级',
    },
    '3060102': {
        'en_US': 'Reversible block log usage is at unsafe levels',
        'zh_HK': '可逆块日志利用处于不安全等级',
    },
    '3070000': {
        'en_US': 'WASM Exception',
        'zh_HK': 'WASM異常',
    },
    '3070001': {
        'en_US': 'Error in WASM page memory',
        'zh_HK': 'WASM内存页错误',
    },
    '3070002': {
        'en_US': 'Runtime Error Processing WASM',
        'zh_HK': '处理WASM时发生运行时错误',
    },
    '3070003': {
        'en_US': 'Serialization Error Processing WASM',
        'zh_HK': '处理WASM时发生序列化错误',
    },
    '3070004': {
        'en_US': 'memcpy with overlapping memory',
        'zh_HK': '内存拷贝时发生地址重叠',
    },
    '3070005': {
        'en_US': 'binaryen exception',
        'zh_HK': 'binaryen異常',
    },
    '3080000': {
        'en_US': 'Resource exhausted exception',
        'zh_HK': '资源耗尽異常',
    },
    '3080001': {
        'en_US': 'Account using more than allotted RAM usage',
        'zh_HK': '账号使用的内存超限',
    },
    '3080002': {
        'en_US': 'Transaction exceeded the current network usage limit imposed on the transaction',
        'zh_HK': '交易网络占用超限',
    },
    '3080003': {
        'en_US': 'Transaction network usage is too much for the remaining allowable usage of the current block',
        'zh_HK': '交易网络占用过高',
    },
    '3080004': {
        'en_US': 'Transaction exceeded the current CPU usage limit imposed on the transaction',
        'zh_HK': '交易CPU佔用超限',
    },
    '3080005': {
        'en_US': 'Transaction CPU usage is too much for the remaining allowable usage of the current block',
        'zh_HK': '交易CPU佔用過高',
    },
    '3080006': {
        'en_US': 'Transaction took too long',
        'zh_HK': '交易用时过长',
    },
    '3080007': {
        'en_US': 'Transaction exceeded the current greylisted account network usage limit',
        'zh_HK': '交易超过当前灰名单账号的网络用量上限',
    },
    '3080008': {
        'en_US': 'Transaction exceeded the current greylisted account CPU usage limit',
        'zh_HK': '交易超過當前灰名單賬號的CPU用量上限',
    },
    '3081001': {
        'en_US': 'Transaction reached the deadline set due to leeway on account CPU limits',
        'zh_HK': '由於賬號CPU限制，交易已經達到截止區',
    },
    '3090000': {
        'en_US': 'Authorization exception',
        'zh_HK': '授權異常',
    },
    '3090001': {
        'en_US': 'Duplicate signature included',
        'zh_HK': '包含重复的签名',
    },
    '3090002': {
        'en_US': 'Irrelevant signature included',
        'zh_HK': '包含不相关的签名',
    },
    '3090003': {
        'en_US': 'Provided keys, permissions, and delays do not satisfy declared authorizations',
        'zh_HK': '提供的密钥、许可和延时不能满足声称的授權',
    },
    '3090004': {
        'en_US': 'Missing required authority',
        'zh_HK': '授權丢失',
    },
    '3090005': {
        'en_US': 'Irrelevant authority included',
        'zh_HK': '包含不相关的授權',
    },
    '3090006': {
        'en_US': 'Insufficient delay',
        'zh_HK': '延时不足',
    },
    '3090007': {
        'en_US': 'Invalid Permission',
        'zh_HK': '许可無效',
    },
    '3090008': {
        'en_US': 'The action is not allowed to be linked with minimum permission',
        'zh_HK': '不允许该动作链接到最小许可',
    },
    '3090009': {
        'en_US': 'The parent permission is invalid',
        'zh_HK': '父级许可無效',
    },
    '3100000': {
        'en_US': 'Miscellaneous exception',
        'zh_HK': '其他異常',
    },
    '3100001': {
        'en_US': 'Internal state is no longer consistent',
        'zh_HK': '内部状态不一致',
    },
    '3100002': {
        'en_US': 'Unknown block',
        'zh_HK': '未知區塊',
    },
    '3100003': {
        'en_US': 'Unknown transaction',
        'zh_HK': '未知交易',
    },
    '3100004': {
        'en_US': 'Corrupted reversible block database was fixed',
        'zh_HK': '被破坏的可逆區塊数据库已修复',
    },
    '3100005': {
        'en_US': 'Extracted genesis state from blocks.log',
        'zh_HK': '从區塊日志中提取的创世状态',
    },
    '3100006': {
        'en_US': 'Subjective exception thrown during block production',
        'zh_HK': '出块时抛出異常',
    },
    '3100007': {
        'en_US': 'Multiple voter info detected',
        'zh_HK': '检测到多个投票人信息',
    },
    '3100008': {
        'en_US': 'Feature is currently unsupported',
        'zh_HK': '当前不支持的特性',
    },
    '3100009': {
        'en_US': 'Node management operation successfully executed',
        'zh_HK': '结果管理操作執行成功',
    },
    '3110000': {
        'en_US': 'Plugin exception',
        'zh_HK': '插件異常',
    },
    '3110001': {
        'en_US': 'Missing Chain API Plugin',
        'zh_HK': 'Chain API插件丢失',
    },
    '3110002': {
        'en_US': 'Missing Wallet API Plugin',
        'zh_HK': 'Wallet API插件丢失',
    },
    '3110003': {
        'en_US': 'Missing History API Plugin',
        'zh_HK': 'History API插件丢失',
    },
    '3110004': {
        'en_US': 'Missing Net API Plugin',
        'zh_HK': 'Net API插件丢失',
    },
    '3110005': {
        'en_US': 'Missing Chain Plugin',
        'zh_HK': 'Chain插件丢失',
    },
    '3110006': {
        'en_US': 'Incorrect plugin configuration',
        'zh_HK': '插件配置不正确',
    },
    '3120000': {
        'en_US': 'Wallet exception',
        'zh_HK': '錢包異常',
    },
    '3120001': {
        'en_US': 'Wallet already exists',
        'zh_HK': '錢包已经存在',
    },
    '3120002': {
        'en_US': 'Nonexistent wallet',
        'zh_HK': '錢包不存在',
    },
    '3120003': {
        'en_US': 'Locked wallet',
        'zh_HK': '已锁定的錢包',
    },
    '3120004': {
        'en_US': 'Missing public key',
        'zh_HK': '公钥丢失',
    },
    '3120005': {
        'en_US': 'Invalid wallet password',
        'zh_HK': '無效的錢包密码',
    },
    '3120006': {
        'en_US': 'No available wallet',
        'zh_HK': '没有有效的錢包',
    },
    '3120007': {
        'en_US': 'Already unlocked',
        'zh_HK': '已经解锁',
    },
    '3120008': {
        'en_US': 'Key already exists',
        'zh_HK': '密钥已经存在',
    },
    '3120009': {
        'en_US': 'Nonexistent key',
        'zh_HK': '不存在的密钥',
    },
    '3120010': {
        'en_US': 'Unsupported key type',
        'zh_HK': '不支持的密钥类型',
    },
    '3120011': {
        'en_US': 'Wallet lock timeout is invalid',
        'zh_HK': '錢包锁定超时無效',
    },
    '3120012': {
        'en_US': 'Secure Enclave Exception',
        'zh_HK': '安全专区異常',
    },
    '3130000': {
        'en_US': 'Actor or contract whitelist/blacklist exception',
        'zh_HK': '執行人或合约白名单/黑名单異常',
    },
    '3130001': {
        'en_US': 'Authorizing actor of transaction is not on the whitelist',
        'zh_HK': '交易的授權執行人不在白名单中',
    },
    '3130002': {
        'en_US': 'Authorizing actor of transaction is on the blacklist',
        'zh_HK': '交易的授權執行人在黑名单中',
    },
    '3130003': {
        'en_US': 'Contract to execute is not on the whitelist',
        'zh_HK': '要執行的合约不在白名单中',
    },
    '3130004': {
        'en_US': 'Contract to execute is on the blacklist',
        'zh_HK': '要執行的合约在黑名单中',
    },
    '3130005': {
        'en_US': 'Action to execute is on the blacklist',
        'zh_HK': '要執行的动作在黑名单中',
    },
    '3130006': {
        'en_US': 'Public key in authority is on the blacklist',
        'zh_HK': '授權中的公钥在黑名单中',
    },
    '3140000': {
        'en_US': 'Exceptions that are allowed to bubble out of emit calls in controller',
        'zh_HK': '控制器異常',
    },
    '3140001': {
        'en_US': 'Block does not match checkpoint',
        'zh_HK': '區塊与检查点不匹配',
    },
    '3160000': {
        'en_US': 'Contract exception',
        'zh_HK': '合约異常',
    },
    '3160001': {
        'en_US': 'The payer of the table data is invalid',
        'zh_HK': '表数据支付账号無效',
    },
    '3160002': {
        'en_US': 'Table access violation',
        'zh_HK': '数据表访问违规',
    },
    '3160003': {
        'en_US': 'Invalid table iterator',
        'zh_HK': '無效的数据表迭代器',
    },
    '3160004': {
        'en_US': 'Table can not be found inside the cache',
        'zh_HK': '缓存中找不到指定的数据表',
    },
    '3160005': {
        'en_US': 'The table operation is not allowed',
        'zh_HK': '不允许数据表操作',
    },
    '3160006': {
        'en_US': 'Invalid contract vm type',
        'zh_HK': '無效的合约虚拟机类型',
    },
    '3160007': {
        'en_US': 'Invalid contract vm version',
        'zh_HK': '無效的合约虚拟机版本',
    },
    '3160008': {
        'en_US': 'Contract is already running this version of code',
        'zh_HK': '合约已经在运行这个版本的代码',
    },
    '3160009': {
        'en_US': 'No wast file found',
        'zh_HK': '，没有找到wast文件',
    },
    '3160010': {
        'en_US': 'No abi file found',
        'zh_HK': '没有找到abi文件',
    },
    '3170000': {
        'en_US': 'Producer exception',
        'zh_HK': '出块人異常',
    },
    '3170001': {
        'en_US': 'Producer private key is not available',
        'zh_HK': '出块人私鑰無效',
    },
    '3170002': {
        'en_US': 'Pending block state is missing',
        'zh_HK': '待定區塊状态丢失',
    },
    '3170003': {
        'en_US': 'Producer is double confirming known range',
        'zh_HK': '出块人双重確認',
    },
    '3170004': {
        'en_US': 'Producer schedule exception',
        'zh_HK': '出块人调度计划異常',
    },
    '3170006': {
        'en_US': 'The producer is not part of current schedule',
        'zh_HK': '出块人不属于当前安排计划',
    },
    '3170007': {
        'en_US': 'The configured snapshot directory does not exist',
        'zh_HK': '配置的快照目錄不存在',
    },
    '3170008': {
        'en_US': 'The requested snapshot already exists',
        'zh_HK': '請求的快照已经存在',
    },
    '3180000': {
        'en_US': 'Reversible Blocks exception',
        'zh_HK': '可逆區塊異常',
    },
    '3180001': {
        'en_US': 'Invalid reversible blocks directory',
        'zh_HK': '無效的可逆區塊目錄',
    },
    '3180002': {
        'en_US': 'Backup directory for reversible blocks already existg',
        'zh_HK': '可逆块的备份目錄已存在',
    },
    '3180003': {
        'en_US': 'Gap in the reversible blocks database',
        'zh_HK': '不连续的可逆區塊数据库',
    },
    '3190000': {
        'en_US': 'Block log exception',
        'zh_HK': '區塊日志異常',
    },
    '3190001': {
        'en_US': 'unsupported version of block log',
        'zh_HK': '不支持的區塊日志版本',
    },
    '3190002': {
        'en_US': 'fail to append block to the block log',
        'zh_HK': '向區塊日志添加區塊时失敗',
    },
    '3190003': {
        'en_US': 'block log can not be found',
        'zh_HK': '找不到區塊日志',
    },
    '3190004': {
        'en_US': 'block log backup dir already exists',
        'zh_HK': '區塊日志备份目錄已存在',
    },
    '3200000': {
        'en_US': 'http exception',
        'zh_HK': 'http異常',
    },
    '3200001': {
        'en_US': 'invalid http client root certificate',
        'zh_HK': '無效的http客户端证书',
    },
    '3200002': {
        'en_US': 'invalid http response',
        'zh_HK': '無效的http請求',
    },
    '3200003': {
        'en_US': 'service resolved to multiple ports',
        'zh_HK': '服務对应多个端口',
    },
    '3200004': {
        'en_US': 'fail to resolve host',
        'zh_HK': '解析主机名失敗',
    },
    '3200005': {
        'en_US': 'http request fail',
        'zh_HK': 'http請求失敗',
    },
    '3200006': {
        'en_US': 'invalid http request',
        'zh_HK': '無效的http請求',
    },
    '3210000': {
        'en_US': 'Resource limit exception',
        'zh_HK': '资源限制異常',
    },
    '3220000': {
        'en_US': 'Mongo DB exception',
        'zh_HK': 'MongoDB異常',
    },
    '3220001': {
        'en_US': 'Fail to insert new data to Mongo DB',
        'zh_HK': 'MongoDB插入数据失敗',
    },
    '3220002': {
        'en_US': 'Fail to update existing data in Mongo DB',
        'zh_HK': 'MongoDB更新数据失敗',
    },
    '3230000': {
        'en_US': 'Contract API exception',
        'zh_HK': '合约API異常',
    },
    '3230001': {
        'en_US': 'Crypto API Exception',
        'zh_HK': '密码学API異常',
    },
    '3230002': {
        'en_US': 'Database API Exception',
        'zh_HK': '数据库API異常',
    },
    '3230003': {
        'en_US': 'Arithmetic Exception',
        'zh_HK': '算术異常',
    },
    '3240000': {
        'en_US': 'Snapshot exception',
        'zh_HK': '快照異常',
    },
    '3240001': {
        'en_US': 'Snapshot Validation Exception',
        'zh_HK': '快照验证異常',
    },
};

export const EOSErrorCode = {
    getEOSErrorMessage:(code:string, lange:any)=> {
        return eosErrorArray[code] ? eosErrorArray[code][lange ? lange : 'zh_HK'] : 'error';
    }
}

